import { HttpError } from '@hrms/shared';

export function errorMessage(err: unknown): string {
  if (!err) return '';
  if (err instanceof HttpError) return err.body?.message || `Request failed (${err.status})`;
  if (err instanceof TypeError && /fetch|network/i.test(err.message)) return 'Cannot reach the server. Check your connection or server URL.';
  if (err instanceof Error) return err.message;
  return String(err);
}

/** Flattens Laravel validation errors (field -> messages[]) into field -> first message. */
export function fieldErrors(err: unknown): Record<string, string> {
  if (err instanceof HttpError && err.body?.errors) {
    const out: Record<string, string> = {};
    for (const [k, v] of Object.entries(err.body.errors)) out[k] = Array.isArray(v) ? v[0] : String(v);
    return out;
  }
  return {};
}
